<template>
  <component
    class="text-center"
    @input="$emit('input', $event)"
    @operator-change="$emit('operator-change', $event)"
    :field="field"
    :is="field.filter.component"
  ></component>
</template>

<script>
import SearchFilter from './SearchFilter.vue'
import DateFilter from './DateFilter.vue'
import NumberFilter from './NumberFilter.vue'
import SelectFilter from './SelectFilter.vue'
import SwitchFilter from './SwitchFilter.vue'
import TimeFilter from './TimeFilter.vue'

export default {
  props: {
    field: {
      type: Object,
      required: true,
    },
  },
  components: {
    SearchFilter,
    DateFilter,
    NumberFilter,
    SelectFilter,
    SwitchFilter,
    TimeFilter,
  },
}
</script>
